import React, { useState } from 'react';
import { Upload, Button } from 'antd';
import { FileImageOutlined } from '@ant-design/icons';

function BtnUploadFile({ postFile = () => {} }) {
  const [uploadLdg, setUploadLdg] = useState(false);
  const onChangeFile = info => {
    setUploadLdg(() => info.file.status === 'uploading');
  };
  return (
    <Upload
      name='file'
      beforeUpload={e => postFile(e)}
      onChange={onChangeFile}
      showUploadList={false}
      accept='image/*'>
      <Button type='text' icon={<FileImageOutlined />} loading={uploadLdg} />
    </Upload>
  );
}

export default BtnUploadFile;
